import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.9435 20.9427C16.4228 21.4634 15.5785 21.4634 15.0578 20.9427L7.05784 12.9427C6.53714 12.422 6.53714 11.5778 7.05784 11.0571C7.57854 10.5364 8.42276 10.5364 8.94346 11.0571L16.0007 18.1143L23.0578 11.0571C23.5785 10.5364 24.4228 10.5364 24.9435 11.0571C25.4642 11.5778 25.4642 12.422 24.9435 12.9427L16.9435 20.9427Z"
    }, null, -1)
  ])))
}
export default { render: render }